import { createStore } from 'vuex';

// 创建一个空的 Vuex store 实例
const store = createStore({});

export default store;